export const STATUS_LABELS = {
  new: "New enquiry", interested: "Interested", awaiting_customer: "Waiting for customer", ready_for_review: "Customer replied",
  offer_sent: "Conditional offer sent", inspection_arranged: "Inspection arranged", purchased: "Purchased", declined: "Not Interested", closed: "Closed",
  category_changed: "Category changed", valuation_requested: "Valuation requested", appointment_set: "Appointment date set", offer_recorded: "Offer recorded",
};
export const STATUS_ORDER = ["new", "interested", "awaiting_customer", "ready_for_review", "offer_sent", "inspection_arranged", "purchased", "declined", "closed"];
export const STATUS_STYLES = {
  new: "bg-[#B3262D]/10 text-[#8F1E24] border-[#B3262D]/30",
  interested: "bg-[#0F2D4A]/5 text-[#0F2D4A] border-[#0F2D4A]/25",
  awaiting_customer: "bg-slate-50 text-slate-700 border-slate-300",
  ready_for_review: "bg-amber-50 text-amber-900 border-amber-300",
  offer_sent: "bg-[#0F2D4A]/5 text-[#0F2D4A] border-[#0F2D4A]/25",
  inspection_arranged: "bg-[#0F2D4A]/5 text-[#0F2D4A] border-[#0F2D4A]/25",
  purchased: "bg-green-50 text-green-900 border-green-300",
  declined: "bg-slate-100 text-slate-600 border-slate-300",
  closed: "bg-slate-100 text-slate-600 border-slate-200",
};
export const CATEGORY_LABELS = { A: "A – Actively buying", B: "B – Manual consideration", C: "C – Not currently buying" };
export const NOT_GUARANTEED = "This is an estimated valuation, not a guaranteed purchase offer.";
export const SUBJECT_TO_REVIEW = "All valuations are subject to review by Harrington's Direct. The price may change depending on vehicle condition, mileage, service history, outstanding finance, previous damage, mechanical issues and other relevant information.";
export const NO_VISIT = "Please wait until we've contacted you before visiting the dealership, so we can review your vehicle and save you an unnecessary journey.";

const YNU = [{ value: "yes", label: "Yes" }, { value: "no", label: "No" }, { value: "unsure", label: "Unsure" }];

export const CONDITION = [
  { value: "excellent", label: "Excellent" }, { value: "good", label: "Good" }, { value: "fair", label: "Fair" },
  { value: "poor", label: "Poor" }, { value: "unsure", label: "Not sure" },
];
export const SERVICE = [
  { value: "full", label: "Full" }, { value: "partial", label: "Partial" }, { value: "none", label: "None" }, { value: "unsure", label: "Not sure" },
];
export const KEYS = [{ value: "1", label: "1" }, { value: "2", label: "2" }, { value: "3+", label: "3 or more" }, { value: "unsure", label: "Not sure" }];
export const METHODS = [
  { value: "phone", label: "Phone call" }, { value: "text", label: "Text message" }, { value: "email", label: "Email" }, { value: "any", label: "No preference" },
];

export const QUESTIONS = [
  { key: "condition", label: "Overall condition", options: CONDITION },
  { key: "mechanical", label: "Does your car have any mechanical problems or warning lights?", options: [{ value: "none", label: "No known problems" }, { value: "minor", label: "Minor issues" }, { value: "major", label: "Major issues" }, { value: "unsure", label: "Not sure" }], details: "faults_details", detailsWhen: ["minor", "major"], detailsLabel: "Briefly, what are they?" },
  { key: "bodywork", label: "Any significant bodywork damage?", options: [{ value: "none", label: "No significant damage" }, { value: "minor", label: "Minor marks" }, { value: "significant", label: "Significant damage" }, { value: "unsure", label: "Not sure" }], details: "damage_details", detailsWhen: ["significant"], detailsLabel: "Briefly describe the damage" },
  { key: "service_history", label: "What service history does your car have?", options: SERVICE },
  { key: "keys", label: "Number of keys", options: KEYS },
  { key: "outstanding_finance", label: "Is there outstanding finance on the car?", options: YNU },
  { key: "written_off", label: "Any accident or insurance write-off history?", options: YNU },
  { key: "mot_status", label: "MOT status", options: [{ value: "valid", label: "Valid MOT" }, { value: "expired", label: "Expired" }, { value: "unsure", label: "Not sure" }] },
];

export const SHORT_QUESTIONS = ["condition", "mechanical", "bodywork", "service_history"];

export const answer = (key, value) => {
  if (value == null || value === "") return "Not given";
  const q = QUESTIONS.find((x) => x.key === key);
  return q?.options.find((o) => o.value === value)?.label || value;
};

export const SLOTS = [
  { id: "front", label: "Front", hint: "Step back so the whole front is in shot" },
  { id: "rear", label: "Rear", hint: "Include the number plate" },
  { id: "left", label: "Left side", hint: "Full side, wheels visible" },
  { id: "right", label: "Right side", hint: "Full side, wheels visible" },
  { id: "interior", label: "Interior", hint: "Front seats and dashboard area" },
  { id: "dashboard", label: "Dashboard / mileage", hint: "Ignition on, showing mileage and any warning lights" },
  { id: "damage", label: "Any damage", hint: "Close-ups of scratches, dents or wear", multiple: true },
  { id: "other", label: "Anything else", hint: "Boot, tyres, service book", multiple: true },
];
export const slotLabel = (id) => SLOTS.find((s) => s.id === id)?.label || id;

export const DATA_LIMITATION =
  "Valuation information is drawn from UK registers and third-party sources at the time of the request. It may be incomplete or out of date, is not a substitute for a physical inspection or professional advice, and must not be the sole basis for a decision to buy, sell, finance or insure a vehicle.";

export const estimateTitle = (kind) => (kind === "harringtons" ? "Harrington's Direct buying estimate" : "General trade estimate");
